<template>

    <section class="pb-8" id="portafolio">

        <v-container fluid>

            <v-row class="titulo_section">
                <v-col cols="12" sm="12">
                    <h1 class="font-weight-bold display-1" align="center">Portafolio </h1>
                </v-col>
            </v-row>


            <v-row justify="center" class=" pt-6">

               
                <v-col  cols="12" sm="6" md="3" class="pb-4" v-for="item in listSystem" :key="item.id"  style="z-index: 1;">
                    <v-hover v-slot="{ hover }">
                    <v-card shaped :elevation="hover ? 10 : 4" :class="{ up: hover }" >
                        <v-row>
                            
                            <v-col cols="12">

                                <v-img v-if="item.id==1" :src="require('@/assets/img_portafolio/spacio.jpg')" @click="ViewPortafolio(item.link)" class="mt-2 img_catalogue"  max-height="200" contain></v-img>
                                <v-img v-if="item.id==2" :src="require('@/assets/img_portafolio/colegio.jpg')" @click="ViewPortafolio(item.link)"  class="mt-2 img_catalogue" max-height="200" contain></v-img>
                                <v-img v-if="item.id==3" :src="require('@/assets/img_portafolio/contigreen.jpg')" @click="ViewPortafolio(item.link)" class="mt-2 img_catalogue" max-height="200" contain></v-img>
                                <v-img v-if="item.id==4" :src="require('@/assets/img_portafolio/oriandes.jpg')" @click="ViewPortafolio(item.link)" class="mt-2 img_catalogue" max-height="200" contain></v-img>



                                <!--
                                <v-img :src="rutaServer+item.imagen.file_link" class="mt-2 img_catalogue" max-height="200" contain @click="ViewImage(item.imagen)"></v-img>
                                -->
                                <!--
                                <v-img :src="rutaServer+item.img" class="mt-2 img_catalogue" max-height="200" contain @click="ViewImage(item.img)"></v-img>
                                -->
                                <!--
                                <v-card class="mx-auto my-8" max-width="200">                                   
                                    <v-img :src="rutaServer+item.imagen[0].file_link" class="mt-2" height="200" contain @click="ViewImage(item.imagen[0].file_link)"></v-img> 
                                <v-card-text>
                                    <div class="text-center">{{item.file_desc}}</div>
                                </v-card-text>                             
                            </v-card> -->
                            </v-col>
                          
                            <v-col cols="3">
                                <div class="d-flex align-start" style="font-size: 0.9rem;"> 
                                    <span class="fa-stack fa-lg">
                                        <i class="fas fa-circle fa-stack-2x color02"></i>
                                        <i class="fas fa-user-tie fa-stack-1x fa-inverse"></i>
                                        <!--<i class="fas fa-hand-holding-dollar fa-stack-1x fa-inverse"></i> -->
                                    </span>                                    
                                </div>  
                            </v-col>
                            <v-col cols="9" class="px-2">
                                <h4 class="font-weight">{{item.titulo}}</h4>
                                <h4 class="font-weight-light">{{item.descripcion  }} </h4> 
                            </v-col>                                

                        </v-row>
                    </v-card>
                    </v-hover>
                </v-col>
             

                <div class="svg-border-waves">
                    <img :src="require('@/assets/img/wave2.svg')" />
                </div>
            </v-row>


        </v-container>




        <!-- <div class="svg-border-waves">
            <img src="~@/assets/img/wave2.svg" />
        </div> -->

    </section>
</template>






<script>
    // import {db} from '@/main'

    export default {
        data: () => ({
            imgOver:false,

            
            listSystem : [

                {
                    id:1,
                    img: "https://cdn.vuetifyjs.com/images/cards/hotel.jpg",
                    titulo: "Spacio",
                    descripcion: "Pagina de con carrito de comprar personalizada",
                    link:"https://spaciovzla.com",
                },
            
                
                {
                    id:2,
                    img: "require('@/assets/img_portafolio/oriandes.jpg')",
                    titulo: "Colegio de enfermeria del edo Carabobo",
                    descripcion: "Pagina del colegio de enfermeria del estado carabob",
                    link:"https://colegioenfermeriaestadocarabobo.org",
                }, 

                {
                    id:3,
                    img: "./assets/img/borderWaves.svg",
                    titulo: "contigreen",
                    descripcion: "Sistema busquedas organizar y buscar documentos ECUADOR",
                    link:"https://fileupload.kwsoluciones.com",
                },

                {
                    id:4,
                    img: "@/assets/img_portafolio/oriandes.jpg",
                    titulo: "Oriandes",
                    descripcion: "Pagina báisca de vigilancia",
                    link:"https://oriandes.kwsoluciones.com/",
                },

               

                               
            ], 

              
           
        }),


        methods: {
         
            ViewPortafolio(link) {
                window.open(  link,   '_blank')
               // window.location.href = link
            },



        }
    };
</script>



<style scoped>
    /*
    #portafolio {
        background-color: var( --background);  
    }
    */
</style>
